import { SortBy } from '../types';

export const dataTypes = [
  'distance',
  'moving_time',
  'count',
  'elevation_gain',
  'suffer_score',
  'tss',
] as const;

export type DataType = (typeof dataTypes)[number];

export const dataTypeLabels: Record<DataType, string> = {
  distance: 'distance (km)',
  moving_time: 'time (h)',
  count: 'count (#)',
  elevation_gain: 'elevation gain (m)',
  suffer_score: 'relative effort',
  tss: 'training stress score',
} as const;

export const dataTypeUnits: Record<DataType, string> = {
  distance: 'km',
  moving_time: 'h',
  count: '#',
  elevation_gain: 'm',
  suffer_score: '',
  tss: '',
} as const;

export const sports = {
  Ride: '🚴',
  Run: '🏃',
  Swim: '🏊',
  VirtualRide: '🚴',
} as const;

export const filters: SortBy[] = [
  'total',
  'alphabetical',
  'cycling',
  'running',
  'swimming',
];
